import { IndianRupee, ShieldCheck, Wrench, Landmark, Zap, TrendingUp } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/landing/Reveal";
import { BENEFITS } from "@/data/content";

const iconMap = { IndianRupee, ShieldCheck, Wrench, Landmark, Zap, TrendingUp };

const Benefits = () => (
  <section className="py-24 md:py-32 bg-brand-grey/60" data-testid="benefits-section">
    <div className="max-shell mx-auto px-4 md:px-8 lg:px-12">
      <Reveal className="flex justify-center text-center">
        <SectionHeading
          eyebrow="Why Switch To Solar"
          title="Real Benefits, From Day One"
          subtitle="Solar is no longer just green — it is one of the smartest long-term investments for any Indian property."
          className="mx-auto"
        />
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {BENEFITS.map((b, i) => {
          const Icon = iconMap[b.icon];
          return (
            <Reveal key={b.title} delay={(i % 3) * 0.08}>
              <div
                className="group h-full flex items-start gap-4 rounded-3xl bg-white border border-slate-100 p-6 shadow-soft transition-transform duration-300 hover:-translate-y-1 hover:shadow-lift"
                data-testid={`benefit-card-${i}`}
              >
                <span className="grid place-items-center h-14 w-14 shrink-0 rounded-2xl bg-brand-green/10 text-brand-green transition-transform duration-300 group-hover:scale-110">
                  <Icon className="h-6 w-6" />
                </span>
                <div>
                  <h3 className="text-lg font-bold text-brand-navy">{b.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-slate-500">{b.desc}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Benefits;
